import { createStyles, rem } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  content: {
    padding: '40px 50px 55px 55px',
    display: 'flex',
    flexDirection: 'column',
    width: 598,
    borderRadius: '24px',
    overflowY: 'auto',
    '.mantine-Modal-header': {
      position: 'inherit'
    },
    [theme.fn.smallerThan(850)]: {
      padding: 20
    }
  },
  modalTitle: {
    fontFamily: `Medium , ${theme.fontFamily}`,
    fontSize: 22,
    fontWeight: 500,
    color: theme.colors.secondary[0],
    [theme.fn.smallerThan(850)]: {
      width: '200px',
      height: 105,
      lineHeight: '34.5px'
    }
  },
  cancelIconModal: {
    cursor: 'pointer',
    zIndex: 1000,
    background: 'white',
    borderRadius: 50,
    top: 55,
    position: 'absolute',
    right: 53,
    ':hover': {
      cursor: 'pointer'
    },
    [theme.fn.smallerThan(850)]: {
      right: 35,
      width: 20,
      height: 20,
      top: 45
    }
  },

  label: {
    color: `${theme.colors.text[1]}`,
    opacity: 0.5,
    paddingBottom: '10px',
    fontSize: '16px',
    fontFamily: 'Regular',
    marginTop: 20
  },
  textInput: {
    color: 'white',
    paddingBottom: '0px',
    paddingLeft: '0px',
    marginBottom: '0px',
    input: {
      fontSize: '16px !important',
      fontFamily: 'Medium !important',
      background: `${theme.colors.background[2]} !important`,
      border: '0px !important',
      borderRadius: '16px !important',
      minHeight: 56
    },
    textarea: {
      fontSize: '16px !important',
      fontFamily: 'Medium !important',
      background: `${theme.colors.background[2]} !important`,
      minHeight: '14vw',
      border: '0px !important',
      borderRadius: '16px !important',
      [theme.fn.smallerThan('xs')]: {
        minHeight: '178px'
      }
    },
    '.mantine-InputWrapper-error': {
      color: '#ED2424',
      fontFamily: 'Regular',
      fontSize: '16px'
    }
  },
  footerWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.fn.smallerThan('xs')]: {
      flexWrap: 'wrap',
      flexDirection: 'column-reverse'
    }
  },
  cancelButton: {
    color: `${theme.colors.secondary[0]}`,
    backgroundColor: `transparent !important`,
    fontFamily: `SemiBold , ${theme.fontFamily}`,
    fontSize: 16,
    letterSpacing: 0.5,
    marginRight: 50,
    width: 120,
    ':hover': {
      backgroundColor: `transparent !important`
    },
    height: 43,
    [theme.fn.smallerThan('xs')]: {
      width: rem(270)
      // textAlign:'center',
    },
    [theme.fn.smallerThan(500)]: {
      minWidth: '100%'
    }
  },
  notifyButton: {
    backgroundColor: `${theme.colors.primary[0]}`,
    fontFamily: `Light , ${theme.fontFamily}`,
    fontFamily: `SemiBold , ${theme.fontFamily}`,
    fontSize: 16,
    letterSpacing: 0.5,
    width: 158,
    ':hover': {
      backgroundColor: theme.colors.primary[0]
    },
    height: 56,
    [theme.fn.smallerThan('xs')]: {
      width: rem(270),
      textAlign: 'center'
    },
    [theme.fn.smallerThan(500)]: {
      minWidth: '100%'
    }
  }
}));
